import script from "./p10-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./p10-report-table.vue?vue&type=script&setup=true&lang=js"

import "./p10-report-table.vue?vue&type=style&index=0&id=cff2a48e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cff2a48e"]])

export default __exports__